module.exports = __webpack_public_path__ + "img/spfc.3a952385.png";